import React from 'react';

import { useTaskQue } from '@/hooks/useTaskQue.hook';
import { useConnectAccount } from '@/hooks/useConnectAccount.hook';
import { useWindowWidth } from './useWindowWidth.hook';
import {
  TaskPublicDto,
  useTaskControllerVerifyTaskMutation,
} from '@/store/services/MidleNestApi.service';
import { forEach } from 'lodash';

export const useTask = (id: string) => {
  // const { profile, reloadProfile } = useProfile();
  const width = useWindowWidth();
  const { connect } = useConnectAccount(id);

  const windowOpenSelf = (props: TaskPublicDto) => {
    setIsWaiting();
    // const newLink = props.visitUrl?.replaceAll('https://midle.io', 'https://app.midle.io');
    location.href = String(props.visitUrl);
  };

  const {
    isWaiting,
    isCompleted,
    isCustomerWaiting,
    setIsWaiting,
    setIsCompleted,
    removeFromWaiting,
  } = useTaskQue(id);

  // const [twitterQuery] = useLazyGetApiV1TwitterGetauthorizeurlQuery();
  const [checkQuest] = useTaskControllerVerifyTaskMutation();

  const isMobile = React.useMemo(() => width < 768, [width]);

  const twitterLike = (props: TaskPublicDto) => {
    setIsWaiting();

    const url = props.visitUrl?.split('/') ?? [];
    const tweet_id = url[url?.length - 1];
    const [cleaned] = tweet_id.split('?');

    window.open(
      !isMobile ? `https://twitter.com/intent/like?tweet_id=${cleaned}` : String(props.visitUrl),
      'like',
      'menubar=1,resizable=1,width=800,height=600',
    );
  };
  const twitterRetweet = (props: TaskPublicDto) => {
    setIsWaiting();

    const url = props.visitUrl?.split('/') ?? [];
    const tweet_id = url[url?.length - 1];
    const [cleaned] = tweet_id.split('?');

    window.open(
      !isMobile ? `https://twitter.com/intent/retweet?tweet_id=${cleaned}` : String(props.visitUrl),
      'retweet',
      'menubar=1,resizable=1,width=800,height=600',
    );
  };
  const twitterFollow = (props: TaskPublicDto) => {
    setIsWaiting();

    const url = props.visitUrl?.split('/') ?? [];
    const screen_name = url[url?.length - 1];
    const [cleaned] = screen_name.split('?');

    window.open(
      !isMobile
        ? `https://twitter.com/intent/follow?screen_name=${cleaned}`
        : String(props.visitUrl),
      'follow',
      'menubar=1,resizable=1,width=800,height=600',
    );
  };

  const twitterQuote = (props: TaskPublicDto) => {
    setIsWaiting();
    const friendsCount = props?.data?.friendsCount ? props.data.friendsCount : 0;
    let result = '';
    for (let i = 0; i < Number(friendsCount); i++) {
      result += '@ ';
    }

    const mention = result.trim();

    window.open(
      `https://twitter.com/intent/tweet?url=${props.visitUrl}&text=${encodeURIComponent(
        `${props.data?.template} ${mention}`,
      )}`,
      'Twitter Quote',
      'menubar=1,resizable=1,width=800,height=600',
    );
  };

  const twitterHashtag = (props: TaskPublicDto) => {
    setIsWaiting();
    const sTwitterShare = `https://twitter.com/intent/tweet?=&text=${encodeURIComponent(
      props?.data?.hashtags || '',
    )}`;
    window.open(String(sTwitterShare), 'Share', 'width=550,height=450');
  };

  const windowOpen = (props: TaskPublicDto) => {
    setIsWaiting();

    if (props.visitUrl)
      if (props.visitUrl.includes('http')) window.open(String(props.visitUrl));
      else window.open('https://' + String(props.visitUrl));
  };

  const onlyCheck = () => {
    setIsWaiting();
  };

  const questCheck = async (id: string, cb: () => void) => {
    await checkQuest(id)
      .unwrap()
      .then((res) => {
        if (res?.result === 'true') {
          //   if (res?.data?.isConnectionRequired) {
          //       if (res?.data?.platform === 'twitter')
          //           dispatch(
          //               systemActions.pushMessage({
          //                   message: 'Connect your Twitter first!',
          //                   link: '/settings/connect',
          //                   linkText: 'Check you connected accounts',
          //               }),
          //           );
          //   }
          // else
          setIsCompleted();
          if (cb) cb();
        }
      })
      .catch((error) => console.log(error))
      .finally(() => removeFromWaiting());
  };

  const complete = (action: string) =>
    ({
      // twitterConnect: connect['twitter'],
      metamaskConnect: windowOpenSelf,
      twitterConnect: windowOpenSelf,
      telegramConnect: windowOpenSelf,
      discordConnect: windowOpenSelf,
      githubConnect: windowOpenSelf,

      twitterFollow: twitterFollow,
      twitterRetweet: twitterRetweet,
      twitterQuote: twitterQuote,
      twitterHashtag: twitterHashtag,
      twitterLike: twitterLike,
      twitterFollowersCount: onlyCheck,
      steamGamesCount: onlyCheck,
      // subscribeYoutube: subscribeYoutube,
      // mintNft: mintNft,
    }[action] || windowOpen);
  const check = (action: string) =>
    ({
      MetamaskConnect: () => null,
      // TwitterConnect: () => questCheck,
      // TelegramConnect: () => questCheck,
      // DiscordConnect: () => questCheck,
      // githubConnect: () => questCheck,
    }[action] || questCheck);

  return { complete, check, isWaiting, isCompleted, isCustomerWaiting };
};
